import { render } from "./UnspalshSection.vue?vue&type=template&id=3fb678f5"
import script from "./UnspalshSection.vue?vue&type=script&lang=js"
export * from "./UnspalshSection.vue?vue&type=script&lang=js"

import "./UnspalshSection.vue?vue&type=style&index=0&id=3fb678f5&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__